// lurik-frontend/src/presentation/pages/workspace/settings/security-section/components/CompanyStatus.tsx
import React from 'react';
import styled from 'styled-components';
import { IUser } from '../../../../../../application/models';

interface CompanyStatusProps {
  enabled: boolean;
  userCount: number;
  users: IUser[];
}

const StatusContainer = styled.div`
  background: #f8f9fa;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
`;

const StatusHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const StatusTitle = styled.h4`
  color: #2c3e50;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
`;

const StatusBadge = styled.span<{ enabled: boolean }>`
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${props => props.enabled ? '#d4edda' : '#f8d7da'};
  color: ${props => props.enabled ? '#155724' : '#721c24'};
  border: 1px solid ${props => props.enabled ? '#c3e6cb' : '#f5c6cb'};
`;

const StatusDetails = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`;

const StatusItem = styled.div`
  text-align: center;
`;

const StatusValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 4px;
`;

const StatusLabel = styled.div`
  font-size: 12px;
  color: #7f8c8d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const CompanyStatus: React.FC<CompanyStatusProps> = ({
  enabled,
  userCount,
  users
}) => {

  const activeUsersCount = users.filter(user => user.status === true).length;

  return (
    <StatusContainer>
      <StatusHeader>
        <StatusTitle>Status da Empresa</StatusTitle>
        <StatusBadge enabled={enabled}>
          {enabled ? '2FA Ativado' : '2FA Desativado'}
        </StatusBadge>
      </StatusHeader>
      
      <StatusDetails>
        <StatusItem>
          <StatusValue>{enabled ? '✅' : '❌'}</StatusValue>
          <StatusLabel>Status 2FA</StatusLabel>
        </StatusItem>
        <StatusItem>
          <StatusValue>{activeUsersCount}</StatusValue>
          <StatusLabel>Usuários Ativos Afetados</StatusLabel>
        </StatusItem>
      </StatusDetails>
    </StatusContainer>
  );
};